import http from '@/utils/http'

export default {
  // 律师前三名展示数据请求接口
  getPositionLawyerList (params) {
    return http.get('/promotion/v1/api/lawyer/reviewLawyerList?pageIndex=' + params.pageIndex +
      '&pageSize=' + params.pageSize + '&city=' + params.city)
  },
  // 资讯文章列表接口
  getArticleList (params) {
    return http.get('/promotion/v1/api/weChatArticle/recommend/provider?pageNo=' + params.pageIndex + '&pageSize=' + params.pageSize +
      '&title=' + params.title
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/service/api/index.js